import { useTranslation } from "react-i18next";
import { LangConstant } from "@/const";
import { GridColDef } from "@/components/common/AppTable/AppTable";

const useApplicationColumn = () => {
  const { t: getLabel } = useTranslation(LangConstant.NS_APPLICATION);

  const columnList: GridColDef<any>[] = [
    {
      field: "applicationId",
      headerName: getLabel("OBJ_APPLICATION_TABLE_COL.applicationID"),
      align: "left",
    },
    {
      field: "name",
      headerName: getLabel("OBJ_APPLICATION_TABLE_COL.applicationName"),
      align: "center",
    },
    {
      field: "host",
      headerName: getLabel("OBJ_APPLICATION_TABLE_COL.applicationHost"),
      align: "center",
    },
    {
      field: "source",
      headerName: getLabel("OBJ_APPLICATION_TABLE_COL.sourceId"),
      align: "center",
      render: cell => {
        return cell.source ? getLabel("OBJ_SOURCE.internal") : getLabel("OBJ_SOURCE.external");
      },
    },
  ];

  return {
    columnList,
  };
};

export default useApplicationColumn;
